module.exports = __webpack_public_path__ + "assets/img/zinzia.875ab899.png";